module.exports = __webpack_public_path__ + "08_medium_gray.cd3b773c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_medium_gray.png
// module id = 21jf
// module chunks = 0